/* Vecno — turns business-day windows into real calendar dates.
   Counts from the store's own clock, skips weekends and any holidays set in the
   theme editor, and rolls to the next working day once the daily cutoff passes. */
(function () {
  var ROOT = document.querySelectorAll('[data-vde]');
  if (!ROOT.length) return;

  function partsIn(tz) {
    try {
      var f = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      var p = {};
      f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() };
    }
  }

  /* noon UTC keeps day arithmetic away from every DST and offset edge */
  function dayOf(p) { return new Date(Date.UTC(p.y, p.m - 1, p.d, 12)); }
  function iso(d) { return d.toISOString().slice(0, 10); }

  function isWorking(d, holidays) {
    var w = d.getUTCDay();
    if (w === 0 || w === 6) return false;
    return holidays.indexOf(iso(d)) === -1;
  }

  function addWorkingDays(from, n, holidays) {
    var d = new Date(from.getTime()), added = 0, guard = 0;
    while (added < n && guard++ < 2000) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isWorking(d, holidays)) added++;
    }
    return d;
  }

  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['January', 'February', 'March', 'April', 'May', 'June',
             'July', 'August', 'September', 'October', 'November', 'December'];

  function fmt(d, withMonth, withYear) {
    var s = DAY[d.getUTCDay()] + ' ' + d.getUTCDate();
    if (withMonth) s += ' ' + MON[d.getUTCMonth()];
    if (withYear) s += ' ' + d.getUTCFullYear();
    return s;
  }

  function range(a, b, thisYear) {
    var sameMonth = a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear();
    /* spell out the year whenever the window lands outside the year the shopper is in */
    var showYearA = a.getUTCFullYear() !== thisYear;
    var showYearB = b.getUTCFullYear() !== thisYear;
    return fmt(a, !sameMonth || showYearA, showYearA) + ' – ' + fmt(b, true, showYearB);
  }

  Array.prototype.forEach.call(ROOT, function (el) {
    if (el.dataset.vdeOn) return;
    el.dataset.vdeOn = '1';

    var tz = el.dataset.tz || 'Asia/Colombo';
    var cutoff = parseInt(el.dataset.cutoff, 10);
    if (isNaN(cutoff)) cutoff = 24;                 // 24 = never roll over
    var holidays = (el.dataset.holidays || '')
      .split(/[\s,]+/).filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });

    var p = partsIn(tz);
    var start = dayOf(p);
    var late = p.h >= cutoff;

    /* orders only start moving on a working day */
    if (late || !isWorking(start, holidays)) {
      start = addWorkingDays(start, 1, holidays);
      if (late && !isWorking(start, holidays)) start = addWorkingDays(start, 1, holidays);
    }

    Array.prototype.forEach.call(el.querySelectorAll('[data-min][data-max]'), function (row) {
      var lo = parseInt(row.dataset.min, 10), hi = parseInt(row.dataset.max, 10);
      if (isNaN(lo) || isNaN(hi)) return;
      var out = row.querySelector('[data-dates]');
      if (out) out.textContent = range(addWorkingDays(start, lo, holidays),
                                       addWorkingDays(start, hi, holidays), p.y);
    });

    var note = el.querySelector('[data-cutoff-note]');
    if (note) {
      if (cutoff >= 24) note.hidden = true;
      else {
        var h = cutoff % 12 || 12, ampm = cutoff < 12 ? 'am' : 'pm';
        note.textContent = late
          ? 'Counted from the next working day — today’s ' + h + ampm + ' cutoff has passed.'
          : 'Order before ' + h + ampm + ' today to start the clock today.';
        note.hidden = false;
      }
    }

    el.classList.add('is-ready');
  });
})();
